import _ from 'lodash';

// DEBOUNCE - used if shouldDebounce is true
const DEBOUNCE_INTERVAL = 1000;
// @ts-expect-error [TS migration] Was not detected by flow
const triggerOnChange = (selectedValue, callback) => callback(selectedValue);

export const debouncedTrigger = _.debounce(triggerOnChange, DEBOUNCE_INTERVAL);
